<div class="card">
  <h5>{{heading}}</h5>
  <p-table #dt1 [value]="orders" dataKey="Id" [rows]="20" [loading]="loading" [rowHover]="true"
    styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm" [paginator]="true"
     [rowsPerPageOptions]="[10, 20, 50, 100, 500, 1000]" [totalRecords]="total" [globalFilterFields]="[]"
    responsiveLayout="scroll" [tableStyle]="{ 'min-width': '75rem' }" [globalFilterFields]="['Name']" [lazy]="true"
    (onLazyLoad)="load($event)">
    <ng-template pTemplate="header">
      <tr class="datatable-th-float-label">
        <th></th>
        <th>
          <div class="p-float-label">
            <input pInputText type="search" class="tw-w-16" [(ngModel)]="criteria.Number"
              (change)="dt1.filter($event.value, 'Number', 'equals')" />
            <label>#</label>
          </div>
        </th>
        <th>Sequence No.</th>
        <th>
          Test
          <p-triStateCheckbox [(ngModel)]="criteria.TestMode"
            (onChange)="dt1.filter($event.value, 'TestMode', 'equals')"></p-triStateCheckbox>
        </th>
        <th>
          <brt-businesss-selector (onSelectionChanged)="dt1.filter($event?.Id, 'BusinessId', 'equals')" />
        </th>
        <th>
          <brt-user-selector (onSelectionChanged)="dt1.filter($event?.Id, 'UserId', 'equals')" />
        </th>
        <th>Amount(Payable)</th>
        <th>Actions</th>
        <th>Order Time</th>
        <th>Last Update</th>
        <th>
          <p-floatLabel>
            <p-multiSelect [options]="orderSources" [(ngModel)]="criteria.Sources"
              (onChange)="dt1.filter($event.value, 'Sources', 'in')" placeholder="Filter by Source" class="w-full"
              [filter]="false" appendTo="body"></p-multiSelect>
            <label>Order Source</label>
          </p-floatLabel>
        </th>
        <th>
          <p-floatLabel>
            <p-multiSelect [options]="orderStatuses" [(ngModel)]="criteria.Statuses"
              (onChange)="dt1.filter($event.value, 'Statuses', 'in')" placeholder="Filter by Status" class="w-full"
              [filter]="false" appendTo="body"></p-multiSelect>
            <label>Order Status</label>
          </p-floatLabel>
        </th>
        <th>
          <p-floatLabel>
            <p-multiSelect [options]="orderTypes" (onChange)="dt1.filter($event.value, 'Types', 'in')"
              placeholder="Filter by Type" class="w-full" [filter]="false" appendTo="body"></p-multiSelect>
            <label>Order Type</label>
          </p-floatLabel>
        </th>
        <th>Location</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-order let-expanded>
      <tr>
        <td>
          <div class="tw-flex tw-gap-1">
            <p-button type="button" pRipple [pRowToggler]="order"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" size="small" [text]="true"></p-button>
            <p-button type="button" pRipple icon="pi pi-history" size="small" [text]="true"
              (click)="actionLogsOrderId=order.Id"></p-button>
            <!-- <button pButton [id]="'action-menu-'+order.Id" type="button" size="small" [text]="order"
              (click)="actionMenu.toggle($event)" icon="pi pi-ellipsis-v"></button> -->
          </div>
        </td>
        <td class="tw-font-semibold">{{order.Number}}</td>
        <td class="tw-font-semibold">{{order.SequenceNumber}}</td>
        <td>
          @if(order.TestMode){
          <p-tag severity="warning">Test Order</p-tag>
          }
        </td>
        <td>
          <brt-business-avatar [businessId]="order.BusinessId" [profile]="order.BusinessProfile" />
        </td>
        <td>
          <brt-user-avatar [userId]="order.UserId" [profile]="order.UserProfile" [identity]="order.UserIdentity" />
        </td>
        <td>
          @if(order.Payment){
          <div class="uw-tag uw-neutral">{{order.Payment?.PaymentMethod || (order.Payment?.IsCash ? 'Cash' : 'Not
            specified')}}</div>
          }
          <div class="tw-font-bold tw-cursor-pointer" (click)="order._amDetail=!order._amDetail">
            {{order.TotalAmount}}
            @if(order.PayableAmount != order.TotalAmount) {({{order.PayableAmount}})}
          </div>
          @if(order._amDetail) {
          <div class="tw-whitespace-nowrap">
            <div>Subtotal: {{order.Subtotal}}</div>
            <div>DeliveryFee: {{order.DeliveryFee}}</div>
            <div>ExtraFees: {{order.SumExtraFees}}</div>
            <div>Discount: -{{order.Discount}}</div>
            <div class="tw-font-semibold">Total: {{order.TotalAmount}}</div>
            <hr />
            <div>BusinessCredit: -{{order.BusinessCredit}}</div>
            <div>MainCredit: -{{order.MainCredit}}</div>
            <div>UsedBalance: -{{order.UsedBalance}}</div>
            <div>OnlinePaymentFee: {{order.OnlinePaymentFee}}</div>
            @if(order.UserPayFee){<div>CommissionAmount: {{order.CommissionAmount}}</div>}
            <div class="tw-font-semibold">PayableAmount: {{order.PayableAmount}}</div>
            <hr />
            @if(!order.IsCash){<div>PayableAmount: {{order.PayableAmount}}</div>}
            <div>UsedBalance: {{order.UsedBalance}}</div>
            <div>MainCredit: {{order.MainCredit}}</div>
            <div>CommissionAmount: -{{order.CommissionAmount}}</div>
            <div>OnlinePaymentFee: -{{order.OnlinePaymentFee}}</div>
            <div class="tw-font-semibold">TransactAmount: {{order.TransactAmount}}</div>
          </div>
          }
        </td>
        <td class="tw-whitespace-nowrap">
          @if(canAccept(order) || canReject(order)) {
          <div class="tw-flex tw-gap-1">
            @if(canAccept(order)) {
            <p-button label="Accept" severity="success" size="small" [loading]="order._processing"
              (click)="acceptPanel.toggle($event)"></p-button>
            }
            @if(canReject(order)) {
            <p-button label="Reject" severity="danger" size="small" [text]="true" [loading]="order._processing"
              (click)="rejectPanel.toggle($event)"></p-button>
            }
          </div>

          <p-overlayPanel #acceptPanel [showCloseIcon]="true" [style]="{ width: '320px' }">
            <div class="tw-flex tw-flex-col tw-gap-2">
              <h6>Specify ETA</h6>
              <div class="tw-flex tw-flex-wrap tw-gap-2 tw-p-2">
                @for(eta of etaOptions; track $index) {
                <p-button label="{{ eta }} min" [text]="eta != defaultEta"
                  (click)="setStatus(order, 'Accepted', eta); acceptPanel.toggle($event)"></p-button>
                }
                <p-button label="Other" [text]="true" (click)="etaInput.value = '75'"></p-button>
              </div>
              <div class="tw-flex tw-gap-2 tw-flex-wrap" [class.tw-hidden]="!etaInput.value">
                <div>
                  <input name="eta-minutes" #etaInput type="number" pInputText placeholder="ETA in minutes" />
                </div>
                <p-button pRipple label="Accept Order & Set ETA" severity="success" size="small"
                  (click)="setStatus(order, 'Accepted', etaInput.value); acceptPanel.toggle($event)"></p-button>
              </div>
            </div>
          </p-overlayPanel>

          <p-overlayPanel #rejectPanel [showCloseIcon]="true" [style]="{ width: '320px' }">
            <div class="tw-flex tw-flex-col tw-gap-2">
              <h6>Specify Reject Reason</h6>
              <div class="tw-flex tw-flex-wrap tw-gap-2 tw-p-2">
                @for(reason of rejectReasons; track $index) {
                <p-button [label]="reason" [text]="true" (click)="reasonInput.value = reason"></p-button>
                }
              </div>
              <div class="tw-flex tw-gap-2 tw-flex-wrap">
                <div>
                  <input name="reject-reason" #reasonInput type="text" pInputText placeholder="Other reason" />
                </div>
                <p-button pRipple label="Reject Order & Send Reason" severity="danger" size="small"
                  (click)="setStatus(order, 'Rejected', null, reasonInput.value); rejectPanel.toggle($event)"></p-button>
              </div>
            </div>
          </p-overlayPanel>
          }
        </td>
        <td class="tw-text-sm">{{order.CompletedTime|date:'short'}}</td>
        <td class="tw-text-sm">{{order.UpdateTime|date:'short'}}</td>
        <td>{{order.Source}}</td>
        <td>{{order.Status}}</td>
        <td>{{order.Type}}</td>
        <td class="tw-whitespace-nowrap">
          <div>{{order.Location?.Postcode}}</div>
          <div class="tw-text-sm">{{order.Location?.Phone}}</div>

        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-order>
      <tr>
        <td colspan="10">
          <img src="/api/order/image/{{order.Id}}" alt="Order Image" class="tw-w-96 tw-h-auto" />
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No order found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr>
        <td colspan="8">Loading order data. Please wait.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<p-dialog header="Action Logs" [(visible)]="actionLogsOrderId" [modal]="true" [maximizable]="true">
  @if(actionLogsOrderId){
  <brt-action-log-list [criteria]="{ItemId: actionLogsOrderId}" />
  }
</p-dialog>